{
    "name": "@crczp/platform",
    "version": "3.10.1",
    "license": "MIT",
    "private": true,
    "scripts": {},
    "dependencies": {
        "@acrodata/code-editor": "^0.6.1",
        "@angular/cdk": "~22.2.0",
        "@angular/common": "~22.2.0",
        "@angular/compiler": "~22.2.0",
        "@angular/core": "~22.2.0",
        "@angular/forms": "~22.2.0",
        "@angular/material": "~22.2.0",
        "@angular/platform-browser": "~22.2.0",
        "@angular/router": "~22.2.0",
        "@codemirror/lang-markdown": "6.5.2",
        "@codemirror/language": "6.13.1",
        "@codemirror/language-data": "6.5.2",
        "@codemirror/search": "^6.7.2",
        "@danielmoncada/angular-datetime-picker": "^22.0.0",
        "@dushixiang/guacamole-common-js": "^1.6.0-fix",
        "@json2csv/plainjs": "^7.0.8",
        "@lezer/highlight": "1.2.5",
        "@ngneat/cashew": "^5.3.0",
        "@sentinel/auth": "22.0.0",
        "@sentinel/common": "22.1.2",
        "@sentinel/components": "22.2.5",
        "@sentinel/layout": "22.1.8",
        "@sqlite.org/sqlite-wasm": "3.53.4-build1",
        "caret-pos": "^2.0.0",
        "comlink": "^4.4.2",
        "date-fns": "^4.4.0",
        "drizzle-orm": "^0.45.3",
        "echarts": "^6.1.0",
        "file-saver": "^2.0.5",
        "marked": "^18.0.14",
        "media-chrome": "4.19.4",
        "ngx-echarts": "^22.0.0",
        "ngx-file-drag-drop": "^11.0.0",
        "ngx-skeleton-loader": "^13.0.0",
        "photoswipe": "5.4.4",
        "rxjs": "^7.8.2",
        "shiki": "4.5.0",
        "uuid": "^14.0.2",
        "vis-data": "^8.0.5",
        "vis-network": "^10.1.2",
        "wavesurfer.js": "8.0.3",
        "zod-validation-error": "^5.0.0",
        "zone.js": "~0.16.3"
    },
    "devDependencies": {
        "@analogjs/vite-plugin-angular": "^2.8.0",
        "@analogjs/vitest-angular": "^2.8.0",
        "@angular-devkit/core": "~22.2.0",
        "@angular-devkit/schematics": "~22.2.0",
        "@angular-eslint/eslint-plugin-template": "^22.5.0",
        "@angular-eslint/template-parser": "^22.5.0",
        "@angular/build": "~22.2.0",
        "@angular/cli": "~22.2.0",
        "@angular/compiler-cli": "~22.2.0",
        "@angular/language-service": "~22.2.0",
        "@eslint/js": "^10.0.1",
        "@nx/angular": "23.2.1",
        "@nx/devkit": "23.2.1",
        "@nx/esbuild": "23.2.1",
        "@nx/eslint": "23.2.1",
        "@nx/eslint-plugin": "23.2.1",
        "@nx/js": "23.2.1",
        "@nx/playwright": "23.2.1",
        "@nx/vite": "23.2.1",
        "@nx/vitest": "23.2.1",
        "@nx/web": "23.2.1",
        "@nx/workspace": "23.2.1",
        "@playwright/test": "^1.63.0",
        "@rdlabo/eslint-plugin-rules": "^22.1.1",
        "@schematics/angular": "~22.2.0",
        "@swc-node/register": "^1.12.1",
        "@swc/cli": "^0.8.1",
        "@swc/core": "^1.16.13",
        "@swc/helpers": "^0.5.23",
        "@types/file-saver": "^2.0.7",
        "@types/node": "^24.19.1",
        "@typescript-eslint/utils": "^8.71.0",
        "@vitest/coverage-v8": "4.1.11",
        "@vitest/web-worker": "4.1.11",
        "angular-eslint": "^22.5.0",
        "angular-file": "^4.0.2",
        "angular-oauth2-oidc": "^22.0.2",
        "angular-oauth2-oidc-jwks": "^22.0.2",
        "autoprefixer": "^10.6.1",
        "drizzle-kit": "^0.31.11",
        "esbuild": "^0.28.2",
        "eslint": "^10.11.0",
        "eslint-config-prettier": "^10.1.8",
        "jiti": "^2.7.0",
        "jsdom": "^30.1.1",
        "jsonc-eslint-parser": "^3.3.0",
        "ng-packagr": "~22.2.4",
        "nx": "23.2.1",
        "postcss": "^8.5.28",
        "prettier": "^3.9.9",
        "ts-node": "^10.9.2",
        "tslib": "^2.8.1",
        "typescript": "~6.0.3",
        "typescript-eslint": "^8.71.0",
        "verdaccio": "^6.10.4",
        "vite": "^8.3.2",
        "vite-tsconfig-paths": "^6.1.1",
        "vitest": "4.1.11",
        "yaml": "^2.9.1",
        "zod": "^4.6.5"
    },
    "overrides": {
        "vitest": "4.1.11",
        "typescript": "~6.0.3",
        "@sentinel/common": "22.1.2",
        "ngx-indexed-db": {
            "@angular/common": "^22.0.0",
            "@angular/core": "^22.0.0",
            "rxjs": "^7.8.0"
        },
        "ngx-file-drag-drop": {
            "@angular/cdk": "^22.0.0",
            "@angular/common": "^22.0.0",
            "@angular/core": "^22.0.0",
            "@angular/material": "^22.0.0",
            "rxjs": "^7.8.0"
        }
    },
    "nx": {
        "includedScripts": []
    },
    "workspaces": [
        "./apps/*",
        "./dist/libs/*"
    ]
}
